import {DialogTitle} from '@headlessui/react';
import {CheckCircleIcon} from '@heroicons/react/20/solid';
import React, {ComponentType, ReactNode} from 'react';

import classNames from 'classnames';
import {Button} from '../../Button';
import {ModalDialog} from './ModalDialog';

interface IProps {
  open: boolean;
  disableClose?: boolean;
  Icon?: ComponentType;
  title: string;
  message: ReactNode;
  buttonCategory?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'secondarycolor'
    | 'danger'
    | undefined;
  onClose: () => void;
}

export const FeedbackDialog: React.FC<IProps> = (props) => {
  const {buttonCategory = 'primary', Icon = CheckCircleIcon} = props;

  const iconBackground = {
    primary: 'bg-blue-100',
    secondary: 'bg-gray-100',
    success: 'bg-green-100',
    secondarycolor: 'bg-gray-100',
    danger: 'bg-red-100',
  };
  const iconColors = {
    primary: 'text-blue-600',
    secondary: 'text-gray-600',
    success: 'text-green-600',
    secondarycolor: 'text-gray-600',
    danger: 'text-red-600',
  };

  const _onClose = () => {
    if (props.disableClose) {
      return;
    }
    props.onClose();
  };

  return (
    <ModalDialog open={props.open} maxWidth="2xl" onClose={_onClose}>
      <div className="sm:flex sm:items-start overflow-x-hidden">
        <div
          className={classNames(
            'mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10',
            iconBackground[buttonCategory] ?? 'text-blue-100',
          )}>
          <Icon
            className={classNames(
              'h-6 w-6',
              iconColors[buttonCategory] ?? 'text-blue-600',
            )}
            aria-hidden="true"
          />
        </div>
        <div className="mt-3 text-center sm:ml-4 sm:mr-2 sm:mt-0 sm:text-left">
          <DialogTitle
            as="h3"
            className="text-base font-semibold leading-6 text-gray-900">
            {props.title}
          </DialogTitle>
          <div className="mt-2">
            <div className="text-sm text-gray-500 whitespace-pre-wrap min-h-60 overflow-scroll">
              {props.message}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:ml-10 sm:mt-4 flex sm:pl-4 align-middle gap-4">
        <Button
          label="Close"
          category={buttonCategory}
          disabled={props.disableClose}
          onClick={props.onClose}
          buttonProps={{
            type: 'button',
          }}
        />
      </div>
    </ModalDialog>
  );
};
